import { FORM_TYPES } from '../consts';
import { useAppStore } from '../store/appStore';

export const getFlowType = (formType: string) => {
  return formType === FORM_TYPES.DIRECTBUY ? FORM_TYPES.PURCHASE : FORM_TYPES.TRIAL.toLowerCase();
};

export const getFlowTypePayload = (formType: string) => {
  const { businessMax } = useAppStore.getState();

  const params = new URLSearchParams(window.location.search);
  let isMax = params.has('max') || businessMax;
  if (isMax) {
    return formType === FORM_TYPES.DIRECTBUY ? 'business_max_purchase' : 'business_max_trial';
  }
  return formType === FORM_TYPES.DIRECTBUY ? FORM_TYPES.PURCHASE : FORM_TYPES.TRIAL.toLowerCase();
};
